import * as React from 'react';

function Pledger(props) {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect
                x="0.25"
                y="0.25"
                width="31.5"
                height="31.5"
                rx="15.75"
                fill="#0F2135"
            />
            <rect
                x="0.5"
                y="0.5"
                width="31"
                height="31"
                rx="15.5"
                stroke="#B0C9EB"
            />
            <mask
                id="mask0_1_506"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="13"
                width="22"
                height="6"
            >
                <path d="M25.4419 13H4V18.5462H25.4419V13Z" fill="white" />
            </mask>
            <g mask="url(#mask0_1_506)">
                <path
                    d="M7.49372 13.256C6.78128 13.256 6.10993 13.6684 5.76741 14.3225C5.76741 14.3225 4.35622 16.8254 4.30142 16.925C4.24662 17.053 4.13701 17.1525 4 17.2094C4.0137 17.2521 4.0411 17.2947 4.0548 17.3374H4.13701C4.23291 17.3374 4.31512 17.2947 4.36992 17.2094L4.84945 16.4699H5.71261C5.91812 16.4699 6.10993 16.3562 6.20584 16.1713L7.28821 14.2514C7.49372 13.8959 7.72664 13.5688 8.00066 13.2702H7.49372V13.256Z"
                    fill="#CFA477"
                />
            </g>
            <mask
                id="mask1_1_506"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="13"
                width="22"
                height="6"
            >
                <path d="M25.4419 13H4V18.5462H25.4419V13Z" fill="white" />
            </mask>
            <g mask="url(#mask1_1_506)">
                <path
                    d="M9.64475 13.8817V15.6451C9.78176 15.6593 9.89137 15.6735 9.98728 15.6735C10.3161 15.6735 10.5764 15.5882 10.7545 15.4033C10.9326 15.2327 11.0148 14.9767 11.0148 14.6496C11.0148 14.2941 10.9326 14.0097 10.7682 13.7964C10.6038 13.583 10.3846 13.4693 10.1243 13.4693C9.97358 13.4693 9.86397 13.5119 9.78176 13.583C9.68586 13.6542 9.64475 13.7537 9.64475 13.8817ZM10.0421 17.2378V17.3374H8.49388V17.2378C8.7542 17.1667 8.8775 16.9819 8.8775 16.6974V13.9528C8.8775 13.6684 8.7542 13.4835 8.49388 13.4266V13.3271C9.08302 13.256 9.63105 13.2133 10.138 13.2133C10.6449 13.2133 11.0559 13.3413 11.3848 13.583C11.7136 13.8248 11.8643 14.1377 11.8643 14.5216C11.8643 14.8345 11.7821 15.1047 11.604 15.3322C11.4259 15.5598 11.2067 15.7304 10.96 15.83C10.6997 15.9295 10.4257 15.9864 10.1243 15.9864C9.97358 15.9864 9.82287 15.9722 9.65846 15.9295V16.6974C9.65846 16.8254 9.69956 16.9392 9.76806 17.0388C9.82287 17.1383 9.91877 17.2094 10.0421 17.2378Z"
                    fill="white"
                />
            </g>
            <mask
                id="mask2_1_506"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="13"
                width="22"
                height="6"
            >
                <path d="M25.4419 13H4V18.5462H25.4419V13Z" fill="white" />
            </mask>
            <g mask="url(#mask2_1_506)">
                <path
                    d="M12.7137 13.0284V16.7543C12.7137 16.9961 12.8097 17.1525 13.0152 17.2378V17.3374H11.6999V17.2378C11.878 17.1525 11.9739 16.9961 11.9739 16.7543V14.0381C11.9739 13.7679 11.8643 13.5973 11.6588 13.5404V13.4408C12.0287 13.3982 12.3575 13.256 12.6178 13.0284H12.7137Z"
                    fill="white"
                />
            </g>
            <mask
                id="mask3_1_506"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="13"
                width="22"
                height="6"
            >
                <path d="M25.4419 13H4V18.5462H25.4419V13Z" fill="white" />
            </mask>
            <g mask="url(#mask3_1_506)">
                <path
                    d="M14.0975 14.735C13.9605 14.735 13.8372 14.8061 13.7413 14.934C13.6454 15.062 13.5769 15.2611 13.5632 15.5171H14.5908C14.5908 15.2753 14.5497 15.0905 14.4675 14.9483C14.3716 14.8061 14.2482 14.735 14.0975 14.735ZM15.3032 16.541C15.221 16.8112 15.084 17.0245 14.8648 17.181C14.6456 17.3374 14.4127 17.4227 14.1523 17.4227C13.8098 17.4227 13.5084 17.2947 13.2618 17.053C13.0015 16.8112 12.8782 16.4699 12.8782 16.0291C12.8782 15.5882 13.0015 15.2327 13.2618 14.9198C13.5221 14.6212 13.8372 14.4648 14.2345 14.4648C14.5497 14.4648 14.81 14.5785 15.0292 14.7776C15.2347 14.9909 15.3443 15.2611 15.3443 15.6024V15.7446H13.5632C13.5769 16.1286 13.6591 16.413 13.8235 16.6121C13.9879 16.8112 14.2071 16.9108 14.4812 16.9108C14.7963 16.9108 15.0429 16.7686 15.2347 16.4841L15.3032 16.541Z"
                    fill="white"
                />
            </g>
            <mask
                id="mask4_1_506"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="13"
                width="22"
                height="6"
            >
                <path d="M25.4419 13H4V18.5462H25.4419V13Z" fill="white" />
            </mask>
            <g mask="url(#mask4_1_506)">
                <path
                    d="M16.8788 16.9534C17.0295 16.9534 17.1939 16.8823 17.3584 16.7401V15.1616C17.3584 15.0336 17.3173 14.934 17.2487 14.8629C17.1802 14.7776 17.0706 14.7492 16.9473 14.7492C16.7281 14.7492 16.55 14.8629 16.413 15.0905C16.276 15.318 16.2075 15.5882 16.2075 15.9153C16.2075 16.2424 16.2623 16.4984 16.3856 16.6832C16.4952 16.8539 16.6596 16.9534 16.8788 16.9534ZM16.4541 17.4227C16.1801 17.4227 15.9472 17.309 15.7417 17.0672C15.5498 16.8254 15.4402 16.5268 15.4402 16.1713C15.4402 15.7162 15.5772 15.318 15.865 14.9909C16.139 14.6638 16.4952 14.4932 16.9199 14.4932C17.0706 14.4932 17.2076 14.5216 17.3447 14.5643V14.0381C17.3447 13.7679 17.2213 13.6115 16.9884 13.5404V13.4408C17.3721 13.3982 17.7009 13.256 17.9612 13.0284H18.0571V16.5268C18.0571 16.797 18.153 16.9819 18.3585 17.053V17.1525C18.0571 17.181 17.7557 17.2805 17.4406 17.4512H17.3447V16.9392H17.331C17.2213 17.0672 17.0843 17.181 16.9199 17.2663C16.7829 17.3658 16.6185 17.4227 16.4541 17.4227Z"
                    fill="white"
                />
            </g>
            <mask
                id="mask5_1_506"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="13"
                width="22"
                height="6"
            >
                <path d="M25.4419 13H4V18.5462H25.4419V13Z" fill="white" />
            </mask>
            <g mask="url(#mask5_1_506)">
                <path
                    d="M19.4272 14.7207C19.1395 14.7207 19.0025 14.9483 19.0025 15.4176C19.0025 15.6309 19.0436 15.8015 19.1121 15.9295C19.1806 16.0575 19.2902 16.1144 19.4272 16.1144C19.5642 16.1144 19.6875 16.0575 19.756 15.9295C19.8382 15.8015 19.8793 15.6309 19.8793 15.4176C19.8656 14.9483 19.7149 14.7207 19.4272 14.7207ZM18.7147 17.8351C18.7147 17.9773 18.7969 18.0769 18.9613 18.1622C19.1258 18.2333 19.3313 18.276 19.6053 18.2618C19.8519 18.2618 20.0437 18.2191 20.1944 18.148C20.3451 18.0769 20.4136 17.9916 20.4136 17.8778C20.4136 17.8351 20.3999 17.7925 20.3862 17.7498C20.3725 17.7071 20.3314 17.6787 20.2903 17.6503C20.2492 17.6218 20.2081 17.5934 20.167 17.5649C20.1259 17.5365 20.0711 17.5223 19.9889 17.4938C19.9067 17.4654 19.8382 17.4512 19.7971 17.4369C19.756 17.4227 19.6738 17.4085 19.5779 17.3801C19.482 17.3516 19.3998 17.3374 19.3587 17.3232C18.9202 17.4085 18.7147 17.5649 18.7147 17.8351ZM21.0028 17.5934C21.0028 17.8778 20.8658 18.0911 20.5781 18.2618C20.2903 18.4324 19.9341 18.5177 19.5094 18.5177C19.345 18.5177 19.1943 18.5035 19.0436 18.4893C18.8928 18.4609 18.7421 18.4324 18.6051 18.3898C18.4681 18.3471 18.3585 18.276 18.2626 18.1907C18.1804 18.1053 18.1393 18.0058 18.1393 17.892C18.1393 17.7498 18.2352 17.636 18.4133 17.5223C18.5914 17.4085 18.838 17.3374 19.1121 17.2947C18.7695 17.1952 18.564 17.053 18.4818 16.8539V16.7828C18.7832 16.669 19.0299 16.5268 19.2217 16.3419C18.9476 16.2993 18.7284 16.1997 18.5503 16.0291C18.3722 15.8584 18.29 15.6593 18.29 15.4318C18.29 15.1758 18.3996 14.9625 18.6188 14.7776C18.838 14.5927 19.1121 14.5074 19.4272 14.5074C19.7423 14.5074 20.03 14.607 20.2629 14.7918C20.441 14.5216 20.6466 14.3794 20.8795 14.3794C20.9617 14.3794 21.0439 14.4079 21.0987 14.4648C21.1535 14.5216 21.1946 14.5927 21.1946 14.6781C21.1946 14.7634 21.1672 14.8345 21.1124 14.8914C21.0576 14.9483 20.9891 14.9767 20.9206 14.9767C20.8521 14.9767 20.7836 14.9483 20.7014 14.8914C20.6329 14.8345 20.5644 14.8061 20.5232 14.8061C20.4684 14.8061 20.4273 14.8345 20.3725 14.8772C20.5232 15.0478 20.6055 15.2327 20.6055 15.4318C20.6055 15.6878 20.4958 15.9011 20.2629 16.086C20.03 16.2708 19.756 16.3562 19.4409 16.3562H19.4135C19.345 16.4273 19.3176 16.4841 19.3176 16.541C19.3176 16.5979 19.3724 16.6548 19.4957 16.6975C19.619 16.7401 19.756 16.7828 19.9204 16.8254C20.0848 16.8681 20.2492 16.9108 20.4273 16.9677C20.5918 17.0245 20.7425 17.1099 20.8521 17.2236C20.948 17.2947 21.0028 17.437 21.0028 17.5934Z"
                    fill="white"
                />
            </g>
            <mask
                id="mask6_1_506"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="13"
                width="22"
                height="6"
            >
                <path d="M25.4419 13H4V18.5462H25.4419V13Z" fill="white" />
            </mask>
            <g mask="url(#mask6_1_506)">
                <path
                    d="M22.1262 14.735C21.9892 14.735 21.8659 14.8061 21.77 14.934C21.6741 15.062 21.6056 15.2611 21.5919 15.5171H22.6195C22.6195 15.2753 22.5784 15.0905 22.4962 14.9483C22.4003 14.8061 22.277 14.735 22.1262 14.735ZM23.3319 16.541C23.2497 16.8112 23.1127 17.0245 22.8935 17.181C22.6743 17.3374 22.4414 17.4227 22.181 17.4227C21.8385 17.4227 21.5371 17.2947 21.2905 17.053C21.0302 16.8112 20.9069 16.4699 20.9069 16.0291C20.9069 15.5882 21.0302 15.2327 21.2905 14.9198C21.5508 14.6212 21.8659 14.4648 22.2633 14.4648C22.5784 14.4648 22.8387 14.5785 23.0579 14.7776C23.2634 14.9909 23.373 15.2611 23.373 15.6024V15.7446H21.5919C21.6056 16.1286 21.6878 16.413 21.8522 16.6121C22.0166 16.8112 22.2359 16.9108 22.5099 16.9108C22.825 16.9108 23.0716 16.7686 23.2634 16.4841L23.3319 16.541Z"
                    fill="white"
                />
            </g>
            <mask
                id="mask7_1_506"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="13"
                width="22"
                height="6"
            >
                <path d="M25.4419 13H4V18.5462H25.4419V13Z" fill="white" />
            </mask>
            <g mask="url(#mask7_1_506)">
                <path
                    d="M24.291 14.7492C24.291 14.7918 24.2773 14.8772 24.2636 15.0194L24.291 15.0336C24.3732 14.8914 24.4691 14.7492 24.6198 14.6354C24.7568 14.5216 24.8938 14.4648 25.0308 14.4648C25.1404 14.4648 25.2364 14.5074 25.3049 14.5785C25.3871 14.6639 25.4145 14.7492 25.4145 14.8772C25.4145 14.9909 25.3871 15.0763 25.3186 15.1474C25.2501 15.2185 25.1678 15.2611 25.0856 15.2611C25.0034 15.2611 24.9075 15.2185 24.8116 15.1331C24.7157 15.0478 24.6335 15.0052 24.565 15.0052C24.4965 15.0052 24.4006 15.0763 24.291 15.2043V16.7401C24.291 16.9534 24.4006 17.1099 24.6061 17.2236V17.3232H23.2497V17.2236C23.4552 17.1241 23.5648 16.9534 23.5648 16.7401V15.4318C23.5648 15.2896 23.5374 15.1758 23.4963 15.0905C23.4415 15.0194 23.373 14.9625 23.2497 14.9341V14.8487C23.4141 14.8203 23.5922 14.7776 23.7704 14.7065C23.9485 14.6354 24.0855 14.5359 24.1951 14.4363H24.291V14.7492Z"
                    fill="white"
                />
            </g>
            <mask
                id="mask8_1_506"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="13"
                width="22"
                height="6"
            >
                <path d="M25.4419 13H4V18.5462H25.4419V13Z" fill="white" />
            </mask>
            <g mask="url(#mask8_1_506)">
                <path
                    d="M9.31594 18.02C9.30224 18.0058 9.30224 17.9916 9.28854 17.9773C9.27484 17.9631 9.26114 17.9631 9.24743 17.9489C9.23373 17.9489 9.22003 17.9347 9.19263 17.9347C9.16523 17.9347 9.13783 17.9347 9.11043 17.9489C9.08302 17.9631 9.06932 17.9773 9.05562 18.0058C9.04192 18.0342 9.02822 18.0485 9.02822 18.0769C9.02822 18.1053 9.01452 18.1338 9.01452 18.1622C9.01452 18.1907 9.01452 18.2191 9.02822 18.2475C9.02822 18.276 9.04192 18.3044 9.05562 18.3186C9.06932 18.3471 9.08302 18.3613 9.11043 18.3755C9.13783 18.3898 9.16523 18.3898 9.19263 18.3898C9.23373 18.3898 9.27484 18.3755 9.30224 18.3471C9.32964 18.3187 9.34334 18.276 9.34334 18.2333H9.48035C9.48035 18.276 9.46665 18.3187 9.45295 18.3471C9.43925 18.3755 9.41184 18.404 9.39814 18.4324C9.37074 18.4609 9.34334 18.4751 9.31594 18.4893C9.28854 18.5035 9.24743 18.5035 9.20633 18.5035C9.15153 18.5035 9.11043 18.4893 9.06932 18.4751C9.02822 18.4609 9.00082 18.4324 8.97342 18.404C8.94602 18.3755 8.91861 18.3329 8.90491 18.2902C8.89121 18.2475 8.87751 18.2049 8.87751 18.148C8.87751 18.0911 8.89121 18.0485 8.90491 18.0058C8.91861 17.9631 8.94602 17.9205 8.97342 17.892C9.00082 17.8636 9.02822 17.8351 9.06932 17.8209C9.11043 17.8067 9.15153 17.7925 9.20633 17.7925C9.24743 17.7925 9.27484 17.7925 9.30224 17.8067C9.32964 17.8209 9.35704 17.8351 9.38444 17.8494C9.41184 17.8636 9.42555 17.892 9.45295 17.9205C9.46665 17.9489 9.48035 17.9916 9.48035 18.02H9.34334C9.32964 18.0485 9.32964 18.0342 9.31594 18.02Z"
                    fill="#CFA477"
                />
            </g>
            <mask
                id="mask9_1_506"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="13"
                width="22"
                height="6"
            >
                <path d="M25.4419 13H4V18.5462H25.4419V13Z" fill="white" />
            </mask>
            <g mask="url(#mask9_1_506)">
                <path
                    d="M10.0421 17.8494V18.1053H10.3024V17.8494H10.4394V18.5177H10.3024V18.2333H10.0421V18.5177H9.89137V17.8494H10.0421Z"
                    fill="#CFA477"
                />
            </g>
            <mask
                id="mask10_1_506"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="13"
                width="22"
                height="6"
            >
                <path d="M25.4419 13H4V18.5462H25.4419V13Z" fill="white" />
            </mask>
            <g mask="url(#mask10_1_506)">
                <path
                    d="M11.2204 18.2618L11.1382 18.0058L11.0422 18.2618H11.2204ZM11.2067 17.8494L11.4533 18.532H11.3026L11.2615 18.3755H11.0148L10.96 18.532H10.8093L11.0559 17.8494H11.2067Z"
                    fill="#CFA477"
                />
            </g>
            <mask
                id="mask11_1_506"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="13"
                width="22"
                height="6"
            >
                <path d="M25.4419 13H4V18.5462H25.4419V13Z" fill="white" />
            </mask>
            <g mask="url(#mask11_1_506)">
                <path
                    d="M12.1246 18.148C12.152 18.148 12.1794 18.1338 12.1931 18.1196C12.2205 18.1196 12.2205 18.0911 12.2205 18.0485C12.2205 18.02 12.2068 17.9916 12.1931 17.9773C12.1794 17.9631 12.152 17.9489 12.1246 17.9489H11.9602V18.1338H12.1246V18.148ZM12.1794 17.8494C12.2068 17.8494 12.2342 17.8494 12.2616 17.8636C12.289 17.8778 12.3027 17.892 12.3164 17.9062C12.3301 17.9205 12.3438 17.9489 12.3575 17.9631C12.3712 17.9916 12.3712 18.0058 12.3712 18.0342C12.3712 18.0769 12.3575 18.1053 12.3438 18.1338C12.3301 18.1622 12.3027 18.1907 12.2616 18.2049C12.2753 18.2049 12.289 18.2191 12.3027 18.2333C12.3164 18.2475 12.3301 18.2618 12.3301 18.276C12.3438 18.2902 12.3438 18.3044 12.3438 18.3187V18.4609C12.3438 18.4751 12.3438 18.4893 12.3575 18.5035C12.3575 18.5177 12.3712 18.532 12.3712 18.532H12.2205C12.2068 18.5035 12.2068 18.4893 12.2068 18.4609C12.2068 18.4324 12.2068 18.404 12.1931 18.3755C12.1931 18.3329 12.1794 18.3187 12.1657 18.3044C12.1794 18.2618 12.152 18.2618 12.1109 18.2618H11.9602V18.532H11.8232V17.8494H12.1794Z"
                    fill="#CFA477"
                />
            </g>
            <mask
                id="mask12_1_506"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="13"
                width="22"
                height="6"
            >
                <path d="M25.4419 13H4V18.5462H25.4419V13Z" fill="white" />
            </mask>
            <g mask="url(#mask12_1_506)">
                <path
                    d="M12.9741 17.8494H12.8371V18.532H12.9741V17.8494Z"
                    fill="#CFA477"
                />
            </g>
            <mask
                id="mask13_1_506"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="13"
                width="22"
                height="6"
            >
                <path d="M25.4419 13H4V18.5462H25.4419V13Z" fill="white" />
            </mask>
            <g mask="url(#mask13_1_506)">
                <path
                    d="M13.3714 17.9631V17.8494H13.9057V17.9631H13.7002V18.5177H13.5632V17.9631H13.3714Z"
                    fill="#CFA477"
                />
            </g>
            <mask
                id="mask14_1_506"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="13"
                width="22"
                height="6"
            >
                <path d="M25.4419 13H4V18.5462H25.4419V13Z" fill="white" />
            </mask>
            <g mask="url(#mask14_1_506)">
                <path
                    d="M14.536 18.2618L14.4538 18.0058L14.3716 18.2618H14.536ZM14.536 17.8494L14.7826 18.532H14.6319L14.5771 18.3755H14.3305L14.2757 18.5178H14.1386L14.3853 17.8351H14.536V17.8494Z"
                    fill="#CFA477"
                />
            </g>
            <mask
                id="mask15_1_506"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="13"
                width="22"
                height="6"
            >
                <path d="M25.4419 13H4V18.5462H25.4419V13Z" fill="white" />
            </mask>
            <g mask="url(#mask15_1_506)">
                <path
                    d="M15.4402 18.404H15.4813C15.495 18.404 15.5087 18.3898 15.5087 18.3898C15.5224 18.3898 15.5224 18.3755 15.5361 18.3613C15.5361 18.3471 15.5498 18.3329 15.5498 18.3187C15.5498 18.2902 15.5361 18.2618 15.5224 18.2475C15.5087 18.2333 15.4813 18.2191 15.4539 18.2191H15.3032V18.404H15.4402ZM15.4265 18.1196C15.4539 18.1196 15.4676 18.1196 15.495 18.1053C15.5087 18.0911 15.5224 18.0769 15.5224 18.0485C15.5224 18.0342 15.5224 18.02 15.5087 18.0058C15.5087 17.9916 15.495 17.9916 15.4813 17.9773C15.4676 17.9773 15.4676 17.9631 15.4539 17.9631H15.2758V18.1196H15.4265ZM15.4539 17.8494C15.4813 17.8494 15.5087 17.8494 15.5361 17.8636C15.5635 17.8636 15.5772 17.8778 15.6046 17.892C15.6183 17.9062 15.632 17.9205 15.6457 17.9489C15.6594 17.9773 15.6594 17.9916 15.6594 18.0342C15.6594 18.0627 15.6457 18.0911 15.632 18.1196C15.6183 18.148 15.5909 18.1622 15.5635 18.1764C15.6046 18.1907 15.632 18.2049 15.6594 18.2333C15.6731 18.2618 15.6868 18.3044 15.6868 18.3471C15.6868 18.3755 15.6868 18.404 15.6731 18.4324C15.6594 18.4609 15.6457 18.4751 15.6183 18.4893C15.5909 18.5035 15.5772 18.5177 15.5498 18.5177C15.5224 18.532 15.495 18.532 15.4676 18.532H15.1525V17.8494H15.4539Z"
                    fill="#CFA477"
                />
            </g>
            <mask
                id="mask16_1_506"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="13"
                width="22"
                height="6"
            >
                <path d="M25.4419 13H4V18.5462H25.4419V13Z" fill="white" />
            </mask>
            <g mask="url(#mask16_1_506)">
                <path
                    d="M16.2486 17.8494V18.404H16.5637V18.5177H16.0979V17.8494H16.2486Z"
                    fill="#CFA477"
                />
            </g>
            <mask
                id="mask17_1_506"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="8"
                y="13"
                width="22"
                height="7"
            >
                <path d="M30 13.4798H8.55814V19.026H30V13.4798Z" fill="white" />
            </mask>
            <g mask="url(#mask17_1_506)">
                <path
                    d="M17.4406 17.8494V17.9631H17.098V18.1196H17.4132V18.2333H17.098V18.404H17.4543V18.5177H16.961V17.8494H17.4406Z"
                    fill="#CFA477"
                />
            </g>
        </svg>
    );
}

export default Pledger;
